module.exports = __webpack_public_path__ + "198882de2b8c5ce4b9de24bcb5006f0e.jpg";